export default Object.freeze([
    { title: 'ログイン', icon: 'mdi-login', url: "/sign-in" },
])
